<mat-drawer-container>
  <mat-drawer-content>
    <div
      class="application-content"
      fxLayout="column"
      [fxHide]="!reportConfigured"
    >
      <div fxLayout="row" fxLayoutAlign="space-between start">
        <div fxLayout="column">
          <div fxFlex>
            <a class="breadcrumbs" (click)="backToCredentialing()"
              ><span class="breadcrumbs-icon"
                ><mat-icon>arrow_back</mat-icon></span
              >
              <span class="breadcrumbs-text">Back to Credentialing</span></a
            >
            <h1 class="report-header">{{ title }}</h1>
          </div>
        </div>
        <div fxFlex fxLayoutAlign="end start">
          <button mat-flat-button color="primary" [matMenuTriggerFor]="menu">
            Action <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <app-export-confirmation
              [viewContext]="viewContext"
              [getExportRequest]="getExportRequest"
              [disabled]="totalResultCount == 0"
            ></app-export-confirmation>
          </mat-menu>
        </div>
      </div>
      <odata-filter
        #filterComponent
        [filterMenuOption]="{
          viewMenuTitle: title,
          readOnlyViewMenu: false,
          hideViewMenuSearchBar: true,
          hideManageColumns: true,
          searchPlaceHolder: 'Search by name or email',
          filterService: filterService,
          viewContextId: viewContextId
        }"
        (selectView)="selectView($event)"
        (createView)="sideBar.create()"
        (editView)="sideBar.edit($event)"
      ></odata-filter>
      <div fxLayout="row" fxLayoutAlign="end center" fxFlex>
        <app-paginator [filterService]="filterService"> </app-paginator>
      </div>
      @if (isFetchingData) {
        <div class="waiting-spinner">
          <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
          <p>Loading...</p>
        </div>
      }
      @if (totalResultCount == 0) {
        <div class="no-results">
          <h3>No results found.</h3>
          <p>Try removing some search filters (or maybe all of them!)</p>
        </div>
      }
      <ng-scrollbar [track]="'all'">
        <div class="app-lineup-table">
          @if (selectedView && report.length && !isFetchingData) {
            <table
              mat-table
              [dataSource]="dataSource"
              matSort
              [matSortActive]="sortColumnName"
              [matSortDirection]="orderDirection"
              (matSortChange)="onSortChange($event)"
            >
              @for (column of customViewColumns; track column) {
                <ng-container [matColumnDef]="column.columnDefinition">
                  @if (!column.isCustomField) {
                    <div>
                      <mat-header-cell *matHeaderCellDef mat-sort-header>{{
                        column.displayName
                      }}</mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        @if (
                          column.systemName ==
                            'credentialApplicationStartDate' ||
                          column.systemName == 'credentialApplicationEndDate' ||
                          column.systemName == 'credentialApplicationUpdatedOn'
                        ) {
                          <div>
                            {{
                              element[column.systemName]
                                | localDate: 'MMM DD, YYYY'
                            }}
                          </div>
                        }
                        @if (column.systemName == 'name') {
                          <div class="name">
                            <span>{{ element[column.systemName] }}</span>
                            @if (notInWorkspaceIds.has(element.id)) {
                              <mat-icon class="workspace-icon"
                                >subdirectory_arrow_right</mat-icon
                              >
                            }
                          </div>
                        }
                        @if (
                          column.systemName !=
                            'credentialApplicationStartDate' &&
                          column.systemName != 'credentialApplicationEndDate' &&
                          column.systemName !=
                            'credentialApplicationUpdatedOn' &&
                          column.systemName != 'name'
                        ) {
                          <div>
                            {{ element[column.systemName] }}
                          </div>
                        }
                      </mat-cell>
                    </div>
                  }
                  @if (column.isCustomField) {
                    <div>
                      <mat-header-cell
                        *matHeaderCellDef
                        [matTooltip]="column.displayName"
                        matTooltipShowDelay="500"
                        matTooltipPosition="left"
                      >
                        <span class="truncate-text">{{
                          column.displayName
                        }}</span>
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">{{
                        getDynamicScenarioColumnValue(
                          column.customFieldId,
                          element
                        )
                      }}</mat-cell>
                    </div>
                  }
                </ng-container>
              }
              <ng-container matColumnDef="contextMenu" sticky>
                <mat-header-cell
                  class="context-menu"
                  *matHeaderCellDef
                ></mat-header-cell>
                <mat-cell class="context-menu" *matCellDef="let element">
                  <div fxFlex fxLayoutAlign="center center">
                    <mat-checkbox
                      color="primary"
                      [(ngModel)]="element.selected"
                      (click)="$event.stopPropagation()"
                    ></mat-checkbox>
                  </div>
                </mat-cell>
              </ng-container>
              <mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns"
                (click)="openSideBar(row)"
                [class.not-clickable]="notInWorkspaceIds.has(row.id)"
              ></mat-row>
            </table>
          }
        </div>
      </ng-scrollbar>
    </div>
  </mat-drawer-content>
  <mat-drawer
    class="drawer"
    [disableClose]="true"
    mode="over"
    position="end"
    #drawer
    [opened]="isDrawerOpen"
  >
    <lineup-views-sidebar
      [title]="'Credential Application View'"
      [filterService]="filterService"
      [viewContextId]="viewContextId"
      (close)="drawer.close()"
      (open)="drawer.open()"
      #sideBar
    ></lineup-views-sidebar>
    <lineup-manage-columns-sidebar
      (open)="drawer.open()"
      (close)="drawer.close()"
      (columnsChanged)="columnsChanged($event)"
      #columnSideBar
    ></lineup-manage-columns-sidebar>
    <router-outlet></router-outlet>
  </mat-drawer>
</mat-drawer-container>
